interface environment {
  domain: string
  protocol: string
  name: string
}

interface origin {
  [key: string]: environment
}

class OriginParser {
  env: environment
  matcher: RegExp

  static EnvOrigins: origin = {
    production: {
      protocol: 'https',
      domain: 'github.com',
      name: 'production',
    },
    proxima: {
      protocol: 'https',
      domain: 'ghe.com',
      name: 'proxima',
    },
    lab: {
      protocol: 'https',
      domain: 'github.com',
      name: 'lab',
    },
    development: {
      protocol: 'http',
      domain: 'github.localhost',
      name: 'dev',
    },
  }

  constructor() {
    this.env = OriginParser.EnvOrigins['production'] // Default to production
    const envHostName = document.getElementById('notebook-host-name')?.getAttribute('data-notebook-host-name')

    let envName
    if (envHostName?.endsWith('.ghe.com')) {
      envName = 'proxima'
    } else {
      envName = document.getElementById('notebook-env')?.getAttribute('data-notebook-env') || 'production'
    }

    const envEnterprise = document.getElementById('notebook-enterprise')?.getAttribute('data-notebook-enterprise')
    if (envEnterprise === 'true') {
      const envProtocol = document.getElementById('notebook-protocol')?.getAttribute('data-notebook-protocol')
      this.matcher = new RegExp(`^${envProtocol}://[^/]*${envHostName}`)
    } else {
      if (envName !== null && envName !== undefined) {
        this.env = OriginParser.EnvOrigins[envName]
        this.matcher = new RegExp(`^${this.env.protocol}://[^/]*${this.env.domain}`)
      } else {
        // default to production
        this.matcher = new RegExp(`^https://[^/]*github.com`)
      }
    }
  }

  match(origin = '') {
    const matches = origin.match(this.matcher)
    return matches !== null && matches[0] !== null
  }
}

export default OriginParser
